// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_21620d3522--dropdown--MUSEO"};